// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Products preview modal — product rows + pagination. Header/close reuse
   knowledgeModal.css so it matches the website preview. */

.pp-count {
  font-size: 12px;
  font-weight: 600;
  color: #5616ea;
  background: #f3f0fc;
  padding: 3px 10px;
  border-radius: 10px;
  margin-left: 10px;
}

.pp-list {
  flex: 1 1;
  overflow-y: auto;
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 4px;
}

.pp-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fcfbff;
}

.pp-thumb {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 10px;
  overflow: hidden;
  background: linear-gradient(135deg, #f5f3ff 0%, #f0f0f5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b9b4d6;
  font-size: 18px;
}
.pp-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }

.pp-main { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 3px; }
.pp-title-row { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; }
.pp-title {
  font-size: 14px; font-weight: 600; color: #1a1730;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.pp-price { font-size: 14px; font-weight: 700; color: #15151f; white-space: nowrap; flex-shrink: 0; }
.pp-specs {
  font-size: 12px; color: #6f6a85;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

.pp-link {
  flex-shrink: 0;
  width: 34px; height: 34px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 10px;
  color: #5616ea; background: #f3f0fc;
  font-size: 12px;
  transition: background 0.15s;
}
.pp-link:hover { background: #e8e1fb; }

/* Pagination */
.pp-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding-top: 14px;
  margin-top: 4px;
  border-top: 1px solid #efedf6;
  flex-shrink: 0;
}
.pp-page-btn {
  width: 34px; height: 34px;
  display: flex; align-items: center; justify-content: center;
  border: 1px solid #e1ddee; background: #fff; color: #3a3550;
  border-radius: 10px; cursor: pointer; font-size: 13px;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.pp-page-btn:hover:not(:disabled) { background: #5616ea; color: #fff; border-color: #5616ea; }
.pp-page-btn:disabled { opacity: 0.4; cursor: default; }
.pp-page-info { font-size: 13px; font-weight: 600; color: #4a4560; min-width: 70px; text-align: center; }
`, "",{"version":3,"sources":["webpack://./src/components/ProductsPreviewModal.css"],"names":[],"mappings":"AAAA;0DAC0D;;AAE1D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA,gBAAgB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAE9E,WAAW,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnF,gBAAgB,aAAa,EAAE,qBAAqB,EAAE,8BAA8B,EAAE,SAAS,EAAE;AACjG;EACE,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACjD,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA,YAAY,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACpG;EACE,eAAe,EAAE,cAAc;EAC/B,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;;AAEA;EACE,cAAc;EACd,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,mBAAmB;EACnB,cAAc,EAAE,mBAAmB;EACnC,eAAe;EACf,4BAA4B;AAC9B;AACA,iBAAiB,mBAAmB,EAAE;;AAEtC,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,yBAAyB,EAAE,gBAAgB,EAAE,cAAc;EAC3D,mBAAmB,EAAE,eAAe,EAAE,eAAe;EACrD,6DAA6D;AAC/D;AACA,oCAAoC,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC7F,wBAAwB,YAAY,EAAE,eAAe,EAAE;AACvD,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE","sourcesContent":["/* Products preview modal — product rows + pagination. Header/close reuse\n   knowledgeModal.css so it matches the website preview. */\n\n.pp-count {\n  font-size: 12px;\n  font-weight: 600;\n  color: #5616ea;\n  background: #f3f0fc;\n  padding: 3px 10px;\n  border-radius: 10px;\n  margin-left: 10px;\n}\n\n.pp-list {\n  flex: 1;\n  overflow-y: auto;\n  margin-top: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-right: 4px;\n}\n\n.pp-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fcfbff;\n}\n\n.pp-thumb {\n  width: 48px;\n  height: 48px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  overflow: hidden;\n  background: linear-gradient(135deg, #f5f3ff 0%, #f0f0f5 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #b9b4d6;\n  font-size: 18px;\n}\n.pp-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }\n\n.pp-main { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 3px; }\n.pp-title-row { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; }\n.pp-title {\n  font-size: 14px; font-weight: 600; color: #1a1730;\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n.pp-price { font-size: 14px; font-weight: 700; color: #15151f; white-space: nowrap; flex-shrink: 0; }\n.pp-specs {\n  font-size: 12px; color: #6f6a85;\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n\n.pp-link {\n  flex-shrink: 0;\n  width: 34px; height: 34px;\n  display: flex; align-items: center; justify-content: center;\n  border-radius: 10px;\n  color: #5616ea; background: #f3f0fc;\n  font-size: 12px;\n  transition: background 0.15s;\n}\n.pp-link:hover { background: #e8e1fb; }\n\n/* Pagination */\n.pp-pager {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding-top: 14px;\n  margin-top: 4px;\n  border-top: 1px solid #efedf6;\n  flex-shrink: 0;\n}\n.pp-page-btn {\n  width: 34px; height: 34px;\n  display: flex; align-items: center; justify-content: center;\n  border: 1px solid #e1ddee; background: #fff; color: #3a3550;\n  border-radius: 10px; cursor: pointer; font-size: 13px;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n.pp-page-btn:hover:not(:disabled) { background: #5616ea; color: #fff; border-color: #5616ea; }\n.pp-page-btn:disabled { opacity: 0.4; cursor: default; }\n.pp-page-info { font-size: 13px; font-weight: 600; color: #4a4560; min-width: 70px; text-align: center; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
